import SectionPriceCalculator from "../../section/SectionPriceCalculator/SectionPriceCalculator";

export const StoryBlokPriceCalculator = () => <SectionPriceCalculator />;
